import {useAutoField} from '../../../../components/AutoForm/useAutoForm';
import {getValidationLevel, getValidation} from './builderValidators';
import {VALIDATION} from './BUILDER_VALIDATION';
import {PlanFormClassKey} from './planFormClasses';

interface PlanValidationLevelResult {
  level: VALIDATION;
  bgClass: PlanFormClassKey;
}

export const usePlanValidationLevel = (
  formikKeyPrefix = 'ignore-me'
): PlanValidationLevelResult => {
  const [, meta] = useAutoField(formikKeyPrefix ?? '');
  const validation = formikKeyPrefix ? getValidation(meta) : undefined;
  const level = getValidationLevel(validation);

  const bgClass: PlanFormClassKey =
    level === VALIDATION.VALID
      ? 'valid'
      : level === VALIDATION.INVALID
      ? 'invalid'
      : level === VALIDATION.PARTIALLY_VALID
      ? 'partial'
      : 'nothing';

  return {level, bgClass};
};
